import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';

/**
 * @method apiGetListWinner
 */

 export default {
     config: function () {
        return Vue.bzbsConfig;
     },

     /**
      * Return List Winner
      */
     apiGetListWinner: function (filename) {
         //var currentTime = new Date().getTime();
         var url = `${this.config().bzbsBlobUrl}/config/cpf/csv/winner/${filename}`;
         return BzbsApi.connectBzbsGetBlob(url);
     },
 }
